import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { IconContext } from 'react-icons';
import { FcOpenedFolder } from 'react-icons/fc';
import { Stack } from '@mui/material';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { alpha } from '@mui/material/styles';

const folderIconProps = { className: 'blue-folder-icon' };

const DragAndDropField: React.FC<DropzoneOptions> = (props) => {
  const { t: translate } = useTranslation();
  const { getRootProps, getInputProps } = useDropzone(props);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height={250}
      border="2px dashed"
      borderColor={(theme) => alpha(theme.palette.common.grey, 0.5)}
      borderRadius="0.75rem"
      sx={{ cursor: 'pointer' }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getRootProps()}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps()} />

      <Typography
        fontSize="h2.fontSize"
        sx={{
          transform: 'rotate(-8deg)',
          '& .blue-folder-icon path:first-of-type': {
            fill: (theme) => `${theme.palette.secondary.main} !important`,
          },
          '& .blue-folder-icon path:last-of-type': {
            fill: (theme) => `${theme.palette.info.main} !important`,
          },
        }}
      >
        <IconContext.Provider value={folderIconProps}>
          <FcOpenedFolder />
        </IconContext.Provider>
      </Typography>

      <Typography variant="body2" color="primary.main">
        {translate('UploadModal.DragAndDropYourFilesHere')}
      </Typography>
    </Stack>
  );
};

export default DragAndDropField;
